export default __webpack_public_path__ + "static/media/CV_thumbnail.7f0cc0f0.png";